import { Link } from 'react-router-dom'

export function NotFound() {
  return (
    <div className="not-found-page container">
      <p className="not-found-code">404</p>
      <h1>Side ikke funnet</h1>
      <p>Siden du leter etter finnes ikke.</p>
      <Link to="/" className="back-link" style={{ marginTop: '1.5rem', display: 'inline-block' }}>
        ← Tilbake til galleri
      </Link>
    </div>
  )
}
